
/// Shop-specific scripts
function secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = h > 0 ? '<b>'+h+'</b>' + (h == 1 ? "hr " : "hrs ") : "";
    var mDisplay = m > 0 ? '<b>'+m+'</b>' + (m == 1 ? "min " : "mins ") : "";
    var sDisplay = s + "s";
    return hDisplay + mDisplay + sDisplay; 
}
function timeTil(lowTides, highTides)
{
  var currTime = new Date().getTime() / 1000;
  var nextLow;
  var prevLow = lowTides[0] - ( lowTides[1] - lowTides[0]);//estimate time diff in case there isn't one
  var i;
  for (i = 0; i < lowTides.length; i++) {
      if (lowTides[i] >= currTime) {
          nextLow = lowTides[i];
          if(i>0){
              prevLow = lowTides[(i-1)];
          }
          break;
      }
  }
  
  var nextHigh;
  var prevHigh = highTides[0] - ( highTides[1] - highTides[0]);//estimate time diff in case there isn't one
  var j;
  for (j = 0; j < highTides.length; j++) {
      if (highTides[j] >= currTime) {
          nextHigh = highTides[j];
          if(j>0){
              prevHigh = highTides[(j-1)];
          }
          break;
      }
  }
  var timeNow = new Date().getTime() / 1000;
		
	var timeTilLow = secondsToHms(nextLow - timeNow);
	var timeTilHigh = secondsToHms(nextHigh - timeNow);
	
	if(timeTilLow<0){
		prevLow = nextLow;
		nextLow = lowTides[(i+1)];
	}
	if(timeTilHigh<0){
		prevHigh = nextHigh;
		nextHigh = highTides[(j+1)];
	}
	
	var tideState;
	var timeDiff;
	var tideRatio;
	var tidePercent;
	var rotate;
	
	if(nextLow < nextHigh){//dropping tide (i.e. next low is first)
		timeDiff = nextLow - prevHigh;
		//timeDiff = nextHigh - nextLow;
		//tideRatio = 1 - ((timeNow - prevHigh) / timeDiff);
		tideRatio = ((nextLow - timeNow) / timeDiff);
		tideState = 'falling';
		rotate = 180 - Math.round((tideRatio * 180));
		tidePercent = Math.round(tideRatio * 100);
	}
	else{//rising
		timeDiff = nextHigh - prevLow;
		//timeDiff = nextLow - nextHigh;
		//tideRatio = ((timeNow - prevLow) / timeDiff);
		tideRatio = ((nextHigh - timeNow) / timeDiff);
		tideState = 'rising';
		rotate = Math.round(360 - (tideRatio * 180));
		tidePercent = 100 - Math.round(tideRatio * 100);
	}
	
	// console.log('Now: ' + timeNow + ' | prevLow: ' + prevLow + ' | prevHigh: ' + prevHigh + ' | nextLow: ' + nextLow + ' | nextHigh: ' + nextHigh + ' | timeDiff:' + timeDiff);
	// console.log(tideState);
	// console.log(tideRatio);
	// console.log(rotate);
  return rotate;
}

    document.addEventListener("DOMContentLoaded", () => {
  // Expose functions on window so they are available from other blocks
  window.getCurrentTidalData = async function (customLat, customLong) {
    const currentDate = new Date();
    const unixTimestamp = Math.floor(currentDate.getTime() / 1000);

    const url = `https://www.worldtides.info/api/v3?extremes&datum=CD&date=today&lat=${customLat}&lon=${customLong}&timezone=Europe/London&localtime&days=1&key=6430b259-12ea-4048-a21f-d689c6d75108`;

    try {
      const response = await fetch(url);
      const data = await response.json();

      if (!data.extremes || data.extremes.length === 0) return;

      let customHtml = "";
      let customNewHtml = "";
      let currentTideType = "";
      let lowTides = [];
      let highTides = [];

      data.extremes.forEach(element => {
        const tideHeight = Number(element.height).toFixed(2);
        const tideType = element.type;
        const tideUnix = element.dt;

        if (tideUnix <= unixTimestamp) {
          currentTideType = tideType;
        }

        if (tideType === "Low") lowTides.push(tideUnix);
        else highTides.push(tideUnix);

        // Extract HH:MM safely
        let tideTime = "";
        if (element.date) {
          const parts = element.date.split("T");
          if (parts[1]) {
            tideTime = parts[1].split("+")[0].split(":");
            tideTime = `${tideTime[0]}:${tideTime[1]}`;
          }
        }

        customHtml += `
          <div class="tide-times-current-tide-single-level data-box">
            <div class="tide-times-current-tide-single-level-row row">
              <div class="tide-times-current-tide-single-level-column col">
                <div class="tide-times-current-tide-single-level-tide"><p>${tideType}</p></div>
              </div>
              <div class="tide-times-current-tide-single-level-column col">
                <div class="tide-times-current-tide-single-level-time"><p>${tideTime}</p></div>
              </div>
              <div class="tide-times-current-tide-single-level-column col">
                <div class="tide-times-current-tide-single-level-height"><p>${tideHeight}m</p></div>
              </div>
            </div>
          </div>`;

        customNewHtml += `
          <div class="tide-times-clock-more-info-blocks-tide-single-list data-box">
            <div class="tide-times-clock-more-info-blocks-tide-lists-row row">
              <div class="tide-times-clock-more-info-blocks-tide-lists-column col col-md-4">
                <div class="tide-times-clock-more-info-blocks-tide-lists-tide"><p>${tideType}</p></div>
              </div>
              <div class="tide-times-clock-more-info-blocks-tide-lists-column col col-md-4">
                <div class="tide-times-clock-more-info-blocks-tide-lists-time"><p>${tideTime}</p></div>
              </div>
              <div class="tide-times-clock-more-info-blocks-tide-lists-column col col-md-4">
                <div class="tide-times-clock-more-info-blocks-tide-lists-height"><p>${tideHeight}m</p></div>
              </div>
            </div>
          </div>`;
      });

      // Replace DOM elements safely
      document.querySelectorAll(".tide-times-current-tide-single-level.data-box").forEach(el => el.remove());
      const listTarget = document.querySelectorAll(".tide-times-current-tide-levels-listing");
      document.querySelectorAll(".tide-times-current-tide-levels-listing").forEach(container => {
        container.insertAdjacentHTML("beforeend", customHtml);
      });

      document.querySelectorAll(".tide-times-clock-more-info-blocks-tide-single-list.data-box").forEach(el => el.remove());
      const moreListTarget = document.querySelectorAll(".tide-times-clock-more-info-blocks-tide-lists");
      document.querySelectorAll(".tide-times-clock-more-info-blocks-tide-lists").forEach(container => {
        container.insertAdjacentHTML("beforeend", customNewHtml);
      });

      // If tide type found → fetch next day's tides and compute rotation
      if (currentTideType) {
        const nextDay = new Date();
        nextDay.setDate(nextDay.getDate() + 1);
        const dateString = nextDay.toISOString().split("T")[0];

        const nextURL = `https://www.worldtides.info/api/v3?extremes&datum=CD&date=${dateString}&lat=${customLat}&lon=${customLong}&timezone=Europe/London&localtime&days=1&key=6430b259-12ea-4048-a21f-d689c6d75108`;

        const nextResponse = await fetch(nextURL);
        const nextData = await nextResponse.json();

        if (nextData.extremes) {
          nextData.extremes.forEach(entry => {
            if (entry.type === "Low") lowTides.push(entry.dt);
            else highTides.push(entry.dt);
          });

          // Use helper to compute rotate (ensure this helper exists in your code)
          if (typeof window.timeTil === "function") {
            const getRotate = window.timeTil(lowTides, highTides);
            //console.log(getRotate);
            if (getRotate !== undefined) {
              const pin = document.querySelector(".tide-times-current-tide-meter-pin");
              if (pin) pin.style.transform = `translate(-50%, -50%) rotate(${getRotate}deg)`;

              const wrapper = document.querySelector(".tide-times-clock-banner-wrapper");
              if (wrapper) {
                wrapper.classList.remove("default", "high-current", "ebb-current", "low-current", "flood-current");

                if (getRotate <= 45) wrapper.classList.add("high-current");
                else if (getRotate <= 110) wrapper.classList.add("ebb-current");
                else if (getRotate <= 245) wrapper.classList.add("low-current");
                else if (getRotate <= 305) wrapper.classList.add("flood-current");
                else wrapper.classList.add("high-current");
              }
            }
          } else {
            console.warn("timeTil function not found on window. Skip rotate calculation.");
          }
        }
      }

      // Update date display
      const formatted = currentDate.toLocaleDateString("en-GB");
      const cd = document.querySelector(".current-date");
      if (cd) cd.textContent = formatted;

    } catch (err) {
      console.error("Error fetching tidal data:", err);
      // avoid using alert in production; kept as console.error
    }
  }; // end getCurrentTidalData

  // Expose datewise function globally
  window.getDateWiseTidalData = async function (customDate, customLat, customLong) {
    const url = `https://www.worldtides.info/api/v3?extremes&datum=CD&date=${customDate}&lat=${customLat}&lon=${customLong}&timezone=Europe/London&localtime&days=1&key=6430b259-12ea-4048-a21f-d689c6d75108`;

    try {
      const res = await fetch(url);
      const data = await res.json();

      if (!data.extremes || data.extremes.length === 0) {
        // clear lists if no data
        document.querySelectorAll(".tide-times-clock-more-info-blocks-tide-single-list.data-box").forEach(e => e.remove());
        return;
      }

      let html = "";

      data.extremes.forEach(item => {
        let time = "";
        if (item.date) {
          const parts = item.date.split("T");
          if (parts[1]) {
            time = parts[1].split("+")[0].split(":");
            time = `${time[0]}:${time[1]}`;
          }
        }

        html += `
          <div class="tide-times-clock-more-info-blocks-tide-single-list data-box">
            <div class="tide-times-clock-more-info-blocks-tide-lists-row row">
              <div class="tide-times-clock-more-info-blocks-tide-lists-column col col-md-4"><p>${item.type}</p></div>
              <div class="tide-times-clock-more-info-blocks-tide-lists-column col col-md-4"><p>${time}</p></div>
              <div class="tide-times-clock-more-info-blocks-tide-lists-column col col-md-4"><p>${Number(item.height).toFixed(2)}m</p></div>
            </div>
          </div>`;
      });

      document.querySelectorAll(".tide-times-clock-more-info-blocks-tide-single-list.data-box").forEach(e => e.remove());
      const target = document.querySelector(".tide-times-clock-more-info-blocks-tide-lists");
      if (target) target.insertAdjacentHTML("beforeend", html);

      // update displayed date
      let safeDate = new Date(customDate);
      const cd = document.querySelector(".current-date");
      if (!isNaN(safeDate) && cd) {
        cd.textContent = safeDate.toLocaleDateString("en-GB");
      } else if (cd) {
        console.error("Invalid date sent:", customDate);
      }
    } catch (err) {
      console.error("Error loading selected date tide data:", err);
    }
  }; // end getDateWiseTidalData


  // =============== INITIAL LOAD (tide banner) ================= //
  (function initialTideLoad() {
    const wrapper = document.querySelector(".tide-times-clock-banner-wrapper");
    if (!wrapper) return;

    const lat = wrapper.dataset.lat;
    const lon = wrapper.dataset.long;

    if (lat && lon) window.getCurrentTidalData(lat.trim(), lon.trim());

    // const title = document.querySelector(".tide-time-custom-banner-title")?.textContent || "";
    // const loc = document.querySelector(".tide-time-custom-banner-location")?.textContent || "";

    // const t1 = document.querySelector(".custom-tide-times-title");
    // const t2 = document.querySelector(".custom-tide-times-full-title");
    // const shopBtnText = document.querySelector(".tide-times-clock-product-wrapper .home-tide-clock-form-button a");

    // if (t1) t1.textContent = title;
    // if (t2) t2.textContent = `${title}, ${loc}`;
    // if (shopBtnText && title) shopBtnText.textContent = `shop ${title} tide clock`;
  })();


  // =============== CALENDAR SECTION ================= //
  (function calendarModule() {
    const section = document.querySelector(`#booking-calendar-main`);
    if (!section) return;

    const monthYearText = section.querySelector(".month-year");
    const calendarDays = section.querySelector(".calendar-days");
    const prevBtn = section.querySelector(".prev");
    const nextBtn = section.querySelector(".next");
    const selectedDateDisplay = document.querySelector(".current-date");

    let date = new Date();
    let selectedDate = null;

    const months = [
      "January","February","March","April","May","June",
      "July","August","September","October","November","December"
    ];

    function formatDisplay(dateObj) {
      let day = String(dateObj.getDate()).padStart(2, "0");
      let month = String(dateObj.getMonth() + 1).padStart(2, "0");
      let year = dateObj.getFullYear();
      return `${year}-${month}-${day}`;
    }

    function updateDisplayedDate() {
      const customDate2 = selectedDate || new Date();
      const formattedDate = formatDisplay(customDate2); // YYYY-MM-DD
      const cald_formatted = customDate2.toLocaleDateString("en-GB");
      if (selectedDateDisplay) selectedDateDisplay.innerHTML = `<strong>${cald_formatted}</strong>`;

      const wrapper = document.querySelector(".tide-times-clock-banner-wrapper");
      if (!wrapper) return;

      const lat = wrapper.dataset.lat?.trim();
      const lon = wrapper.dataset.long?.trim();

      if (lat && lon && formattedDate) {
        // call global function
        window.getDateWiseTidalData(formattedDate, lat, lon);
      } else {
        console.error("Location or date missing:", lat, lon, formattedDate);
      }
    }

    function renderCalendar() {
      if (!calendarDays || !monthYearText) return;

      calendarDays.innerHTML = "";
      let year = date.getFullYear();
      let month = date.getMonth();
      const today = new Date();

      monthYearText.textContent = `${months[month]} ${year}`;

      let firstDay = new Date(year, month, 1).getDay();
      // convert so Monday = 0 ... Sunday = 6 (if that's intended)
      firstDay = (firstDay + 6) % 7;

      let totalDays = new Date(year, month + 1, 0).getDate();

      for (let i = 0; i < firstDay; i++) {
        calendarDays.innerHTML += `<div class="empty"></div>`;
      }

      for (let d = 1; d <= totalDays; d++) {
        let classes = "day";

        // highlight today's date
        if (
          d === today.getDate() &&
          month === today.getMonth() &&
          year === today.getFullYear()
        ) {
          classes += " today";
        }

        // highlight selected date
        if (
          selectedDate &&
          d === selectedDate.getDate() &&
          month === selectedDate.getMonth() &&
          year === selectedDate.getFullYear()
        ) {
          classes += " selected";
        }

        calendarDays.innerHTML += `<div class="${classes}" data-day="${d}">${d}</div>`;
      }

      updateDisplayedDate();
    }

    calendarDays.addEventListener("click", (e) => {
      const dayEl = e.target.closest(".day");
      if (dayEl && dayEl.dataset.day) {
        selectedDate = new Date(date.getFullYear(), date.getMonth(), Number(dayEl.dataset.day));
        renderCalendar();
      }
    });

    prevBtn?.addEventListener("click", () => {
      date.setMonth(date.getMonth() - 1);
      renderCalendar();
    });

    nextBtn?.addEventListener("click", () => {
      date.setMonth(date.getMonth() + 1);
      renderCalendar();
    });

    renderCalendar();
  })();

});
